<div class="main-container multi-turn-team" dir="ltr">
  <div class="multichat-header">
    <mat-tab-group
      #tabGroup
      [selectedIndex]="selectedTabIndex"
      (selectedIndexChange)="onTabIndexChange($event)"
      class="multichat-tabs"
    >
      <mat-tab>
        <ng-template mat-tab-label>
          <span class="iq-tab-label">
            <i class="fa-solid fa-clipboard-list iq-tab-icon iq-tab-icon--summary" aria-hidden="true"></i>
            <span>Summary</span>
          </span>
        </ng-template>

        <div class="messages-container-inner">
          <div
            class="chat-placeholder-grid-container"
            *ngIf="!summarySucceeded && !summaryError && !isLoading"
          >
            <img
              *ngIf="showLogo"
              [src]="currentOption.logoUrl"
              [class.fading]="logoFading"
              [class.circular-logo]="currentOption.logoUrl.includes('x5-baby.webp')"
              class="grid-item-logo vendor-logo"
              alt=""
            />

            <h1 class="placeholder-title" *ngIf="!showMainSubtitle" [class.fading]="modelNameFading">
              <span
                [class]="modelNameClass"
                style="direction:ltr; unicode-bidi:isolate; display:inline-block; white-space:nowrap;"
              >
                <span
                  *ngFor="let letter of modelNameLetters; let i = index; trackBy: trackByLetter"
                  class="model-name-letter"
                  [class.waving]="isLetterWaving(i)"
                  [style.color]="getLetterColor(i)"
                  [style.animation-delay]="isLetterWaving(i) ? '0s' : '0s'"
                >{{ letter.char === ' ' ? '\u00A0' : letter.char }}</span>
              </span>
            </h1>

            <h1 class="placeholder-subtitle jizz bigal-sub" *ngIf="showMainSubtitle">
              The Leading AI Models, All In One Place
            </h1>

            <h1 class="placeholder-subtitle bigal-sub" *ngIf="!showMainSubtitle" [class.fading]="logoFading">
              {{ currentPlaceholder }}
            </h1>
          </div>

          <div class="message-content" *ngIf="summarySucceeded && teamSummary">
            <div class="markdown prism-content" [innerHTML]="formattedSummary" appCodeHighlight></div>
          </div>

          <div class="error-message" *ngIf="summaryError">{{ summaryError }}</div>

        </div>
      </mat-tab>

      <mat-tab *ngFor="let modelId of selectedModels; index as i">
        <ng-template mat-tab-label>
          <span
            class="iq-tab-label"
            [class.iq-tab-label--writer]="modelId === 'palmyrax5'"
            [class.iq-tab-label--mistral]="modelId === 'mistraliq'"
          >
            <img
              *ngIf="modelId !== 'palmyrax5'"
              [src]="getVendorLogo(modelId) || summaryLogoSrc"
              class="iq-tab-logo"
              alt=""
            />
            <i *ngIf="modelId === 'palmyrax5'" class="fa-solid fa-brain iq-tab-icon iq-tab-icon--writer" aria-hidden="true"></i>
            <span class="iq-tab-label__title">{{ tabLabel(modelId) }}</span>
            <span
              *ngIf="tabStatuses[i] === 'success'"
              class="iq-tab-status iq-tab-status--ok"
              aria-label="Success"
              >✔</span
            >
            <span
              *ngIf="tabStatuses[i] === 'error'"
              class="iq-tab-status iq-tab-status--err"
              aria-label="Error"
              >✖</span
            >
          </span>
        </ng-template>

        <div class="messages-container-inner">
          <div
            class="chat-placeholder-grid-container"
            *ngIf="!rawOutputs[i] && !isLoading"
          >
            <img
              [src]="getVendorLogo(modelId) || summaryLogoSrc"
              class="grid-item-logo vendor-logo"
              alt=""
            />
            <h1 class="placeholder-subtitle bigal-sub">{{ placeholderHint(modelId) }}</h1>
          </div>

          <div class="message-content" *ngIf="rawOutputs[i]">
            <div class="markdown prism-content" [innerHTML]="formattedOutputs[i]" appCodeHighlight></div>
          </div>
        </div>
      </mat-tab>
    </mat-tab-group>
  </div>

  <div class="messages-container" #scrollRegion>
    <app-bird-loader *ngIf="isLoading" label="Thinking"></app-bird-loader>
    <div
      class="iq-submission-preview iq-submission-preview--below-loader"
      *ngIf="submittedText && (summarySucceeded || summaryError || isLoading)"
    >
      <div class="iq-submission-preview__label">Your submission</div>
      <div class="markdown prism-content" [innerHTML]="formattedSubmittedWriting" appCodeHighlight></div>
    </div>
    <div class="error-message" *ngIf="error">{{ error }}</div>
  </div>

  <div class="bottomcontainer">
    <div class="input-container">
      <div class="composer-shell">
        <div class="textarea-wrapper iq-composer">
          <textarea
            #userInputTextarea
            class="user-input-textarea"
            [(ngModel)]="inputText"
            rows="1"
            placeholder="Write about unique patterns"
            [disabled]="isLoading || loading"
            (keydown)="onPrimaryTextareaKeydown($event)"
            (input)="updateWordCount()"
            dir="auto"
          ></textarea>

          <button
            class="btn-send-fixed"
            type="button"
            (click)="onSubmit()"
            [disabled]="isLoading || loading || !inputText.trim()"
          >
            <i class="fas fa-arrow-up send-arrow-icon" aria-hidden="true"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
